import fetchGraphQl from "./fetchGraphQl";
import { useQuery } from "react-query";

const fetchMiningData =
  (userId: string, { startDate, endDate }: any) => async () => {
    const { data = { miningData: [] }, error } = await fetchGraphQl(
      `
      query queryMiningData {
        miningData: mining_payment(
          where: {date_created: {_gt: "${startDate.toISOString()}", _lt: "${endDate.toISOString()}"}},
          order_by: {date_created: asc}
        ) {
          exchange_rate: bitcoin_euro_exchange_rate
          bitcoin_mined
          timestamp: date_created
          euros_mined
          hashrate
          id
        }
      }
    `,
      "queryMiningData",
      userId
    ) ?? {};

    let total = {
      bitcoinMined: 0,
      eurosMined: 0,
      exchangeRate: 0,
      timestamp: ''
    };

    if (!error) {
      data.miningData.forEach((dataItem: any, index: number) => {
        total.bitcoinMined += dataItem.bitcoin_mined;
        total.eurosMined += dataItem.euros_mined;
        total.exchangeRate = dataItem.exchange_rate;
        total.timestamp = dataItem.timestamp;
        data.miningData[index].value = dataItem.euros_mined;
      });
    }

    return { data: data.miningData, total };
  };

export const useMiningData = (userId: string, dayRange: any, farmName: string) => {
  return useQuery(["mining", dayRange, farmName], fetchMiningData(userId, dayRange), {
    refetchOnWindowFocus: true,
  });
};
